<!--
  One inline control per dynamic-lottie change. The kind is decided at row
  build time and stays stable for the life of the control. We use *ngIf on the
  discriminator so Angular's strict template checker narrows the EditorRow
  union and recognises kind-specific properties (e.g. row.value, row.range,
  row.hex). ngSwitch would skip the narrowing.

  All bindings read PRE-COMPUTED properties on the row — no helper methods
  on the CD hot path. Conversion happens in row.on…() handlers, which only
  fire on real user input (and re-emit upward via (valueChange)).
-->
<ng-container *ngIf="activeRow as row">
    <!-- TEXT: chip at rest, input on click. -->
    <div class="dvc dvc-text" *ngIf="row.kind === 'text'">
        <button
            type="button"
            class="value-readout text-readout"
            *ngIf="!row.editing"
            [title]="row.value"
            (click)="row.startEdit()">
            <span class="readout-value">{{ row.displayValue }}</span>
        </button>
        <mat-form-field
            appearance="outline"
            class="value-field"
            *ngIf="row.editing"
            (keydown)="row.onEditKeydown($event)">
            <input
                matInput
                cdkFocusInitial
                [value]="row.value"
                (input)="onTextChange($any($event.target).value)"
                (blur)="row.onInputBlur()"
                placeholder="value" />
        </mat-form-field>
    </div>

    <!-- NUMBER: chip at rest, slider + numeric on click. -->
    <div class="dvc dvc-number" *ngIf="row.kind === 'number'">
        <button
            type="button"
            class="value-readout"
            *ngIf="!row.editing"
            (click)="row.startEdit()">
            <span class="readout-value monospace">{{ row.displayValue }}</span>
        </button>
        <div
            class="number-input"
            *ngIf="row.editing"
            (focusout)="row.endEditIfFocusLeft($event)"
            (keydown)="row.onEditKeydown($event)">
            <input
                type="range"
                class="range-slider"
                [min]="row.range.min"
                [max]="row.range.max"
                [step]="row.range.step"
                [value]="row.value"
                (input)="onNumberChange($any($event.target).value)" />
            <input
                type="number"
                class="number-readout"
                [min]="row.range.min"
                [max]="row.range.max"
                [step]="row.range.step"
                [value]="row.value"
                (input)="onNumberChange($any($event.target).value)" />
        </div>
    </div>

    <!-- COLOR (fill/stroke/etc. rgba01 array): swatch + hex + invisible native picker. -->
    <div class="dvc dvc-color" *ngIf="row.kind === 'color'">
        <label class="color-input">
            <input
                type="color"
                class="color-picker"
                [value]="row.hex"
                (input)="onHexChange($any($event.target).value)" />
            <span class="color-swatch" [style.background]="row.hex"></span>
            <span class="color-hex monospace">{{ row.hex }}</span>
        </label>
    </div>

    <!-- RGB TRIPLET (TextR0/TextG0/TextB0 collapsed). -->
    <div class="dvc dvc-rgb" *ngIf="row.kind === 'rgb'">
        <label class="color-input">
            <input
                type="color"
                class="color-picker"
                [value]="row.hex"
                (input)="onHexChange($any($event.target).value)" />
            <span class="color-swatch" [style.background]="row.hex"></span>
            <span class="color-hex monospace">{{ row.hex }}</span>
        </label>
    </div>

    <!-- TOGGLE: pill switch. -->
    <div class="dvc dvc-toggle" *ngIf="row.kind === 'toggle'">
        <label class="toggle-input">
            <input
                type="checkbox"
                class="toggle-checkbox"
                [checked]="row.on"
                (change)="onToggle($any($event.target).checked)" />
            <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </label>
    </div>
</ng-container>
